import { render, staticRenderFns } from "./CheckoutFail.vue?vue&type=template&id=0c8e5d80&scoped=true&"
import script from "./CheckoutFail.vue?vue&type=script&lang=ts&"
export * from "./CheckoutFail.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutFail.vue?vue&type=style&index=0&id=0c8e5d80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e5d80",
  null
  
)

export default component.exports